import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { ProdutosResponseDTO } from '../../models/produto.models';
import { ProdutosDTO } from '../../models/produto.models';

@Injectable({
  providedIn: 'root',
})
export class ProdutosService {
  private baseUrl = '/item';

  constructor(private apiService: ApiService) {}

  get(url: string, data?: any): Observable<ProdutosResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<ProdutosResponseDTO>(path);
  }
  getById<T>(url: string): Observable<ProdutosDTO> {
    return this.apiService.read<ProdutosDTO>(url);
  }

  post<T>(url: string, data: ProdutosDTO): Observable<ProdutosDTO> {
    return this.apiService.create<ProdutosDTO>(url, data);
  }

  put<T>(url: string, data: ProdutosDTO): Observable<ProdutosDTO> {
    return this.apiService.update<ProdutosDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

  getItens(page: number, size: number): Observable<any> {
    return this.apiService.get(`${this.baseUrl}?page=${page}&size=${size}`);
  }

  getItensPorGrupo(grupoId: number, page: number, size: number): Observable<any> {
    return this.apiService.get(
      `${this.baseUrl}/buscarPorGrupo?grupo=${grupoId}&page=${page}&size=${size}`
    );
  }

  listarItensSaldoMenorIgualEstoque(): Observable<ProdutosDTO[]> {
    return this.apiService.read<ProdutosDTO[]>(`${this.baseUrl}/listarItensSaldoMenorIgualEstoque`);
  }

  buscarPorNomeOuBarras(termo: string): Observable<any> {
    return this.apiService.get(
      `${this.baseUrl}/buscarPorNomeOuBarrasOuCodigoItemOuCodigoFabricante?nomeOuBarrasOuCodigoItemOuCodigoFabricante=${termo}`
    );
  }

  gerarEtiquetaPdf(
    itemId: number,
    tipo: string,
    quantidade: number,
    quantidadeImpressa?: number
  ): Observable<string> {
    let url = `${this.baseUrl}/listar-pdf-etiqueta/${itemId}/impressao/${tipo}/quantidade/${quantidade}`;
    if (quantidadeImpressa !== undefined && quantidadeImpressa !== null) {
      url += `?quantidadeImpressa=${quantidadeImpressa}`;
    }
    return this.apiService.readText(url);
  }
}
